module.exports = __webpack_public_path__ + "img/card_6.f96636c2.png";